import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '@app/core';
import { environment } from '@env/environment';

import { UntilDestroy } from '@ngneat/until-destroy';

export interface QuestionHintData {
  information_text: string;
  information_image: string;
}

@UntilDestroy()
@Component({
  selector: 'question-hint-dialog',
  templateUrl: 'question-hint-dialog.component.html',
})
export class QuestionHintDialogComponent
  extends BaseComponent
  implements OnInit
{
  public questionHintData!: QuestionHintData;
  public baseUrl =
    environment.serverUrl + environment.apiVersion + '/images/images/';

  constructor(
    public dialogRef: MatDialogRef<QuestionHintDialogComponent>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.data.hintData) {
      this.questionHintData = this.data.hintData;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  close(data?: any): void {
    this.dialogRef.close(data);
  }
}
